"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCivicPassesForDid = exports.getWalletsForDid = exports.gatekeeperNetworks = void 0;
const tslib_1 = require("tslib");
const web3_js_1 = require("@solana/web3.js");
const ramda_1 = require("ramda");
const passClient_1 = require("./passClient");
const types_1 = require("../types");
exports.gatekeeperNetworks = {
    gatbGF9DvLAw3kWyn1EmH5Nh1Sqp8sTukF7yaQpSc71: types_1.GatekeeperNetwork.GENESIS,
    ni1jXzPTq1yTqo67tUmVgnp22b1qGAAZCtPmHtskqYG: types_1.GatekeeperNetwork.NILE,
    bni1ewus6aMxTxBi5SAfzEmmXLf8KcVFRmTfproJuKw: types_1.GatekeeperNetwork.BLUENILE,
    mos1x4hXqmmmWz5s8btUsM1aHxdY3tUvNHf7sfK37Y6: types_1.GatekeeperNetwork.MOSELLE,
    ignREusXmGrscGNUesoU9mxfds9AiYTezUKex2PsZV6: types_1.GatekeeperNetwork.IGNITE,
    uniqobk8oGh4XBLMqM68K8M2zNu3CdYX7q5go7whQiv: types_1.GatekeeperNetwork.UNIQUENESS,
};
const getWalletsForDid = (didDocument) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const { verificationMethod } = didDocument;
    const pickWallet = (0, ramda_1.prop)("publicKeyBase58");
    const getBase58PublicKey = (0, ramda_1.map)(pickWallet);
    const rejectNil = (0, ramda_1.reject)(ramda_1.isNil);
    const toSolanaPublicKey = (0, ramda_1.tryCatch)((str) => new web3_js_1.PublicKey(str), (0, ramda_1.always)(null));
    const toSolanaPublicKeys = (0, ramda_1.map)(toSolanaPublicKey);
    return (0, ramda_1.pipe)(getBase58PublicKey, toSolanaPublicKeys, rejectNil)((_a = verificationMethod) !== null && _a !== void 0 ? _a : []);
});
exports.getWalletsForDid = getWalletsForDid;
const findPasses = (connection, owner, gateKeeperNetworks) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    return (yield Promise.all(gateKeeperNetworks.map((network) => tslib_1.__awaiter(void 0, void 0, void 0, function* () { return (0, passClient_1.findGatewayToken)(connection, owner, new web3_js_1.PublicKey(network)); })))).filter(Boolean);
});
const getCivicPassesForDid = (didDocument, connection, queryGatekeeperNetworks = Object.keys(exports.gatekeeperNetworks)) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    const wallets = yield (0, exports.getWalletsForDid)(didDocument);
    const gatewayTokens = yield Promise.all(wallets.map((owner) => findPasses(connection, owner, queryGatekeeperNetworks)));
    return (0, ramda_1.flatten)(gatewayTokens);
});
exports.getCivicPassesForDid = getCivicPassesForDid;
